import { hasAttachmentAtomType } from './hasAttachmentAtomType';
/**
 * Creates an attachment array for a certain atom type in a correlation.
 *
 * @param {Correlation} correlation
 * @param {string} atomType
 */
export function addAttachmentAtomType(correlation, atomType) {
    if (!hasAttachmentAtomType(correlation, atomType)) {
        correlation.attachment[atomType] = [];
    }
    return correlation;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRkQXR0YWNobWVudEF0b21UeXBlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxpdGllcy9jb3JyZWxhdGlvbi9hZGRBdHRhY2htZW50QXRvbVR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFFLHFCQUFxQixFQUFFLE1BQU0seUJBQXlCLENBQUM7QUFFaEU7Ozs7O0dBS0c7QUFDSCxNQUFNLFVBQVUscUJBQXFCLENBQ25DLFdBQXdCLEVBQ3hCLFFBQWdCO0lBRWhCLElBQUksQ0FBQyxxQkFBcUIsQ0FBQyxXQUFXLEVBQUUsUUFBUSxDQUFDLEVBQUU7UUFDakQsV0FBVyxDQUFDLFVBQVUsQ0FBQyxRQUFRLENBQUMsR0FBRyxFQUFFLENBQUM7S0FDdkM7SUFFRCxPQUFPLFdBQVcsQ0FBQztBQUNyQixDQUFDIn0=